<template>
    <section class="section">
        <div class="hero">
            <div class="hero-head has-text-centered">
                <h1 class="title is-1">EDAR Overview</h1>
            </div>
        </div>
        <br>
        <div class="container">
            <div class="tile is-ancestor" style="flex-wrap: wrap; justify-content: center;">
                <div v-for="(edar, index) in edars" v-bind:key="index"
                     class="tile is-parent" style="justify-content: center;">
                    <router-link :to="{name: 'edar_detail', params: {edarId: edar.id}}"
                        class="tile is-child card" style="max-width: 23rem; min-width: 20rem; width: 20rem;"
                    >
                        <header class="card-header"
                                :class="{
                                    'has-background-heat-edar-logo-blue': edar.status === 'Online',
                                    'has-background-warning': edar.status === 'Faulted',
                                    'has-background-danger': edar.status === 'Offline',
                                }"
                        >
                            <h1 class="card-header-title title has-text-white" style="margin: 0;">{{edar.name}}</h1>
                            <span class="card-header-title" style="max-width: fit-content;">
                                <router-link tag="button" class="button title is-7"
                                             :to="{name: 'edar_staff_viewer', params: {edarId: edar.id}}"
                                >
                                    LIVE
                                </router-link>
                            </span>
                        </header>
                        <div class="card-content">
                            <div v-if="edar.fault_detected">
                                <div class="is-inline-flex is-inline-block edar_card-data" style="flex-wrap: wrap;">
                                    <div v-for="(annunciator, index) in edar.last_status_message.activeAnnunciators" v-bind:key="annunciator.title + index"
                                         class="has-background-danger has-text-white button" style="margin-right: 0.1rem;"
                                         :title="annunciator.message"
                                    >
                                        {{ annunciator.title }}
                                    </div>
                                </div>
                            </div>
                            <h3 v-else class="title is-4">No Faults Detected</h3>
                            <div style="margin-top: 1em;">
                                <span v-for="(info, index) in edar.infos"  v-bind:key="info.name + index" v-if="info.summary.length"
                                    :title="info.about"
                                >
                                    {{info.summary}},
                                </span>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "Overview",
        computed: {
            ...mapState('edar', [
                'edars',
            ]),
        },
    }
</script>

<style scoped>
    .edar_card-notice {
        width: 5rem;
        min-width: fit-content;
        margin-right: 0.5rem;
    }
    .edar_card-data {
        max-width: 100%;
    }
</style>